import {
  chainDynamicValue,
  DynamicValue,
  useComponentState,
} from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Col, Form } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Filter, { FiltersState } from "src/components/Filter";
import FiltersModal from "src/components/FiltersModal";
import MqPhone from "src/components/MqPhone";
import Sort from "src/components/Sort";
import Translate from "src/components/Translate";
import constants from "src/constants";
import matchMedia from "src/functions/matchMedia";
import Funnel from "src/icons/Funnel";
import { sListHeader } from "src/styles/sListHeader.module.scss";
import { TypeSelectOption } from "src/types/TypeSelectOption";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  sortOptions: TypeSelectOption[];
  filtersState: DynamicValue<FiltersState>;
  numberOfItems: number;
};

function ListHeader({
  style,
  className,
  sortOptions,
  filtersState,
  numberOfItems,
}: Props) {
  const openFilters = useComponentState<boolean>(false);

  return (
    <>
      {constants.Show.navSort || constants.Show.navFilter ? (
        <Form className={composeClassNames([sListHeader, "list-header"])}>
          <Accordion
            defaultActiveKey={
              matchMedia(constants.MediaQueries.phone) ? `` : `0`
            }
          >
            <MqPhone>
              <Accordion.Toggle className={`accordion-toggle`} eventKey={`0`}>
                <Funnel />
                <Translate tKey={`Sort & Filter`} />
              </Accordion.Toggle>
            </MqPhone>
            <Accordion.Collapse className={`accordion-collapse`} eventKey={`0`}>
              <Form.Row>
                <Col sm={8}>
                  {constants.Show.navFilter ? (
                    <Filter
                      filtersState={filtersState}
                      openFilters={openFilters}
                    />
                  ) : null}
                </Col>
                <Col sm={4}>
                  {constants.Show.navSort ? (
                    <Sort
                      value={
                        chainDynamicValue(
                          filtersState,
                          "sort"
                        ) as DynamicValue<string>
                      }
                      data={sortOptions}
                    />
                  ) : null}
                </Col>
              </Form.Row>
            </Accordion.Collapse>
          </Accordion>
        </Form>
      ) : null}
      {openFilters.value ? (
        <FiltersModal
          filtersState={filtersState}
          openFilters={openFilters}
          numberOfItems={numberOfItems}
        />
      ) : null}
    </>
  );
}

export default ListHeader;
